import { usePage } from "@inertiajs/react";
import type { PublicProps } from "@/types";

const IDV_VERIFICATION_URL = "https://auth.hackclub.com/verifications/document";

export default function IdvVerificationAlert() {
  const { props } = usePage<PublicProps>();
  const economyOn =
    props.program.shop_enabled || props.program.projects_enabled;

  // IDV only gates buying and shipping. With the economy off there is nothing
  // behind the gate, so asking someone to scan an ID is a dead end.
  if (!economyOn) return null;

  if (!props.user || props.user.verification_status === "verified") {
    return null;
  }

  return (
    <a
      href={IDV_VERIFICATION_URL}
      className="border-line bg-goldenrod text-ink shadow-card duration-fast ease-standard flex flex-col gap-1 border-2 p-5 transition-transform hover:-translate-y-0.5"
    >
      <span className="font-display text-heading font-bold">
        You aren't verified!
      </span>
      <span className="text-body text-ink-muted">
        Verify your identity to be able to buy items from the shop and get your
        projects reviewed.
      </span>
    </a>
  );
}
